import { ReactNode, useMemo } from 'react'
import { faHashtag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { slugify } from '@commutifi-fe/utils'
import './styles.scss'

export const useAnchorLink = ({ headerText }: { headerText: ReactNode }) => {
  // If we have a heading, make it lower case
  const anchor = typeof headerText === 'string' ? slugify(headerText) : ''

  return useMemo(
    () => ({
      anchor,
      anchorLink: anchor ? (
        <a
          href={`#${anchor}`}
          className="markdown-anchor-link"
          aria-label={`Link to section "${headerText}"`}
          tabIndex={0}
        >
          <FontAwesomeIcon icon={faHashtag} />
        </a>
      ) : null
    }),
    [anchor, headerText]
  )
}
